import {Directive, ViewContainerRef} from '@angular/core';

@Directive({standalone: true, selector: '[pubFooter]'})
export class FooterDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}
